/* ==========================================================================
   Pairs Well With — High Cotton Textile
   Single-variant companions add straight to cart.
   Multi-variant companions open a right-hand drawer with a variant picker.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-pww]');
  if (!root) return;

  var products = {};
  var dataEl = document.getElementById('pww-data');
  if (dataEl) {
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = {}; }
  }

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var overlay, drawer, lastFocus, state = null;

  /* ---------- helpers ---------- */

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function buildDrawer() {
    overlay = document.createElement('div');
    overlay.className = 'pww-overlay';
    overlay.addEventListener('click', closeDrawer);

    drawer = document.createElement('div');
    drawer.className = 'pww-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function openDrawer(handle) {
    var product = products[handle];
    if (!product) return;
    if (!drawer) buildDrawer();

    lastFocus = document.activeElement;
    state = { product: product, selected: product.options.map(function (o) { return o.values[0]; }) };

    // Prefer the first variant that is actually purchasable.
    var firstAvailable = product.variants.filter(function (v) { return v.available; })[0];
    if (firstAvailable) state.selected = firstAvailable.options.slice();

    renderDrawer();
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      var close = drawer.querySelector('.pww-drawer__close');
      if (close) close.focus();
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function currentVariant() {
    if (!state) return null;
    return state.product.variants.filter(function (v) {
      return v.options.every(function (val, i) { return val === state.selected[i]; });
    })[0] || null;
  }

  function valueAvailable(optIndex, value) {
    return state.product.variants.some(function (v) {
      if (!v.available) return false;
      return v.options.every(function (val, i) {
        return i === optIndex ? val === value : val === state.selected[i];
      });
    });
  }


  // A companion that needs a monogram cannot be added blind from a drawer -
  // there is nowhere to type the name. Match Caden Lane: send them to the
  // product page with a Personalize button instead.
  function needsPersonalisation() {
    if (!state) return false;
    return state.product.options.some(function (opt, i) {
      if (!/personaliz/i.test(opt.name)) return false;
      return /^\s*yes/i.test(state.selected[i] || '');
    });
  }

  function renderDrawer() {
    var p = state.product;
    var variant = currentVariant();
    var image = (variant && variant.image) || p.image;

    var html = '';
    html += '<div class="pww-drawer__head">';
    html += '<h2 class="pww-drawer__title">' + p.title + '</h2>';
    html += '<button type="button" class="pww-drawer__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M5 5 L19 19 M19 5 L5 19"></path></svg></button>';
    html += '</div>'

    html += '<div class="pww-drawer__body">';
    if (image) {
      html += '<img class="pww-drawer__image" src="' + image + '" alt="' + p.title + '" loading="lazy">';
    }

    p.options.forEach(function (opt, i) {
      html += '<p class="pww-drawer__optname">' + opt.name + '</p>';
      html += '<div class="pww-drawer__options" data-opt-index="' + i + '">';
      opt.values.forEach(function (value) {
        var isOn = state.selected[i] === value;
        var ok = valueAvailable(i, value);
        html += '<button type="button" class="pww-opt' + (ok ? '' : ' is-unavailable') + '"';
        html += ' aria-pressed="' + (isOn ? 'true' : 'false') + '"';
        html += ' data-value="' + value.replace(/"/g, '&quot;') + '">' + value + '</button>';
      });
      html += '</div>';
    });

    if (variant && variant.note) {
      html += '<p class="pww-drawer__note">' + variant.note + '</p>';
    }
    html += '</div>'

    html += '<div class="pww-drawer__foot">';
    if (variant && variant.available && needsPersonalisation()) {
      html += '<a class="pww-atc pww-atc--link" href="' + (p.url || '#') + '?variant=' + variant.id + '">';
      html += '<span class="pww-atc__label">Personalize</span>';
      html += '<span class="pww-atc__price">' + money(variant.price) + '</span>';
      html += '</a>';
    } else if (variant && variant.available) {
      html += '<button type="button" class="pww-atc" data-pww-drawer-add data-variant-id="' + variant.id + '">';
      html += '<span class="pww-atc__label">Add to cart</span>';
      html += '<span class="pww-atc__price">' + money(variant.price) + '</span>';
      html += '</button>';
    } else {
      html += '<button type="button" class="pww-atc" disabled><span class="pww-atc__label">Sold out</span></button>';
    }
    html += '</div>'

    drawer.innerHTML = html;

    drawer.querySelector('.pww-drawer__close').addEventListener('click', closeDrawer);

    drawer.querySelectorAll('.pww-drawer__options').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-opt-index'), 10);
      group.querySelectorAll('.pww-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.selected[index] = btn.getAttribute('data-value');
          renderDrawer();
        });
      });
    });

    var addBtn = drawer.querySelector('[data-pww-drawer-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addToCart(addBtn.getAttribute('data-variant-id'), addBtn, true);
      });
    }
  }

  /* ---------- cart ---------- */

  function addToCart(variantId, button, fromDrawer) {
    button.classList.add('is-loading');
    button.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
        if (fromDrawer) closeDrawer();
        refreshCart();
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
        window.location.href = '/cart';
      });
  }

  // Impulse listens for these; we fire all of them and fall back to a reload
  // only if nothing on the page responds.
  function refreshCart() {
    var handled = false;
    ['cart:build', 'cart:refresh', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    if (window.theme && window.theme.cart && typeof window.theme.cart.updateCart === 'function') {
      window.theme.cart.updateCart();
      handled = true;
    }
    if (window.theme && typeof window.theme.openCartDrawer === 'function') {
      window.theme.openCartDrawer();
      handled = true;
    }

    // If the theme's cart drawer did not pick it up, send the shopper to /cart
    // rather than leaving them wondering whether the add worked.
    if (!handled) {
      setTimeout(function () {
        var count = document.querySelector('.cart-link__bubble, [data-cart-count]');
        if (!count) window.location.href = '/cart';
      }, 400);
    }
  }

  /* ---------- bind cards ---------- */

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pww-add]');
    if (!btn) return;
    e.preventDefault();

    var handle = btn.getAttribute('data-pww-add');
    var variantId = btn.getAttribute('data-variant-id');

    if (btn.getAttribute('data-multi') === 'true') {
      openDrawer(handle);
    } else if (variantId) {
      addToCart(variantId, btn, false);
    }
  });

  /* ---------- mobile carousel: dots + wrap-around ---------- */

  var track = root.querySelector('.pww__track');
  var dots = Array.prototype.slice.call(root.querySelectorAll('.pww__dot'));

  if (track && track.children.length) {
    var real = Array.prototype.slice.call(track.children);
    var count = real.length;

    // Clone the last slide before the first and the first after the last, so a
    // swipe past either end lands on a copy and we silently jump to the real
    // one. That gives an endless carousel like Caden Lane's, using the native
    // scroll-snap rather than a JS animation.
    if (count > 1) {
      var head = real[count - 1].cloneNode(true);
      var tail = real[0].cloneNode(true);
      // aria-hidden alone is not enough: a keyboard user could still tab into
      // the duplicated cards. Take their controls out of the tab order too.
      [head, tail].forEach(function (clone) {
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      });
      track.insertBefore(head, real[0]);
      track.appendChild(tail);
    }

    var offset = count > 1 ? 1 : 0;
    var jumping = false;

    // Measure from the elements themselves so the 12px gap between slides
    // never accumulates into drift.
    function leftOf(i) {
      var el = track.children[i];
      return el ? el.offsetLeft - track.offsetLeft : 0;
    }

    function goTo(i, smooth) {
      if (!track.children[i]) return;
      track.scrollTo({ left: leftOf(i), behavior: smooth ? 'smooth' : 'auto' });
    }

    function nearest() {
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var d = Math.abs(leftOf(i) - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function paintDots(r) {
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === r ? 'true' : 'false');
      });
    }

    function sync() {
      if (jumping) return;
      var i = nearest();

      if (count > 1 && (i === 0 || i === count + 1)) {
        jumping = true;
        i = (i === 0) ? count : 1;
        goTo(i, false);
        window.setTimeout(function () { jumping = false; }, 40);
      }

      paintDots(Math.min(Math.max(i - offset, 0), count - 1));
    }

    track.addEventListener('scroll', function () {
      window.clearTimeout(track._t);
      track._t = window.setTimeout(sync, 90);
    });

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { goTo(n + offset, true); });
    });

    // Park on the first real slide once the carousel is actually visible.
    function park() {
      if (track.clientWidth > 0) {
        goTo(offset, false);
        paintDots(0);
      }
    }
    requestAnimationFrame(park);
    window.addEventListener('resize', function () {
      window.clearTimeout(track._r);
      track._r = window.setTimeout(park, 200);
    });
  }
})();
